<script setup lang="ts">
  import { useComponentConfig } from '@/shared/lib/tenant'

  const props = withDefaults(
    defineProps<{
      class?: string
    }>(),
    {
      class: 'pointer-events-none absolute top-0 right-61',
    },
  )

  const { componentsConfig } = useComponentConfig()
  const decorationImage = computed(() => componentsConfig.value?.common?.decorationImage)
</script>

<template>
  <NImage
    v-if="decorationImage"
    :src="decorationImage"
    alt=""
    :class="props.class"
  />
</template>
